/**
 * siteGrants.js — client de l'autorité de gestion DATÉE (lot 3 §3.2, D3=b, « le
 * manager de garde »).
 *
 * Chemins : `/api/v1/sites/:id/grants` et `/api/v1/sites/grants/:id/revoke`
 * (backend/routes/site_grant_routes.mjs). Réservé aux comptes gestionnaire — le
 * serveur refuse, ce module ne masque rien.
 *
 * `site_management_grant` S'AJOUTE à `user_site_access` (le périmètre stable), il
 * ne le remplace pas : c'est l'objet d'une garde/astreinte pour une PÉRIODE.
 *
 * @module api/siteGrants
 */
import { apiRequest } from './core.js';

export const siteGrantsAPI = {
  /**
   * @param {number|string} siteId
   * @param {{ activeOnly?: boolean }} [opts]
   */
  list: (siteId, { activeOnly = false } = {}) =>
    apiRequest(`/sites/${siteId}/grants${activeOnly ? '?active=1' : ''}`),

  /**
   * @param {number|string} siteId
   * @param {{ user_id: number, valid_from: string, valid_to: string, reason?: string }} payload
   *   `valid_from`/`valid_to` en ISO 8601 (instants, ADR-013 §3) — pas de date civile nue.
   */
  create: (siteId, payload) =>
    apiRequest(`/sites/${siteId}/grants`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  revoke: (grantId) =>
    apiRequest(`/sites/grants/${grantId}/revoke`, {
      method: 'POST',
    }),
};

export default siteGrantsAPI;
